export function sendWhatsappMessage(phoneNumber: string, message: string) {
  const trimmedPhoneNumber = phoneNumber.replace(/\s/g, "")
  window.open(`https://api.whatsapp.com/send/?phone=${trimmedPhoneNumber}&text=${encodeURIComponent(message)}&type=phone_number&app_absent=0`, 'blank')
}
